import React from 'react';
import SlideLayout from '../layouts/SlideLayout';
import { ContentSlideProps } from '../types';
import '../styles/ContentSlide.css';

const ContentSlide: React.FC<ContentSlideProps> = ({ title, content, footer }) => {
  return (
    <SlideLayout footer={footer} className="content-slide">
      <div className="content-slide-wrapper">
        <h2 className="content-title">{title}</h2>
        <div className="content-body">{content}</div>
      </div>
    </SlideLayout>
  );
};

export default ContentSlide;
